import { BagLocation } from "@m4a3/api-client";
/**
 * Interface for location with emoji mapping
 */
export interface StorageLocationInfo {
  id: BagLocation;
  label: string;
  emoji: string;
}
  
/**
 * Storage location definitions with their respective emojis and labels
 */
export const STORAGE_LOCATIONS: StorageLocationInfo[] = [
  { id: BagLocation.SHELF, label: 'Shelf', emoji: '≡' },
  { id: BagLocation.HOT, label: 'Heater', emoji: '🔥' },
  { id: BagLocation.COLD, label: 'Fridge', emoji: '❄️' }
];
